import gql from 'graphql-tag';

export const SmsChannelInfoFields = gql`
  fragment SmsChannelInfoFields on SmsChannelConnection {
    totalCount
    unreadCount
  }
`;

export const AppointmentFields = gql`
  fragment AppointmentFields on Appointment {
    id
    startAt
    endAt
    status
  }
`;

export const ContactFields = gql`
  fragment ContactFields on Contact {
    id
    firstName
    lastName
    avatarColor
    avatarMedia {
      extensionType
      uri
      sourceUuid
    }
    primaryPhoneNumber {
      id
      number
      insertedAt
    }
    alternativePhoneNumbers {
      number
      insertedAt
    }
    tags {
      id
      assignedAt
      tag {
        id
        name
      }
    }
    zipCode {
      value
      city
      state
    }
  }
`;

export const PhoneNumberFields = gql`
  fragment PhoneNumberFields on ContactPhoneNumber {
    id
    contactId
    number
    insertedAt
  }
`;

export const ChannelInteractionFields = gql`
  fragment ChannelInteractionFields on ChannelInteraction {
    id
    content
    insertedAt
    type
    smsAutoReplyId
  }
`;

export const PageInfoFields = gql`
  fragment PageInfoFields on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
`;

export const AccountFields = gql`
  fragment AccountFields on Account {
    id
    name
    description
    snapflowTitle
    isVerified
    industryType
    numOfContacts
    insertedAt
    updatedAt
    avatarMedia {
      extensionType
      sourceUuid
      uri
    }
    coverMedia {
      extensionType
      sourceUuid
      uri
    }
    virtualPhoneNumbers {
      id
      phoneNumber
      friendlyName
    }
  }
`;

export const OptInFormFields = gql`
  fragment OptInFormFields on OptInForm {
    id
    shortId
    isActive
    title
    subtitle
    afterSubmission
    agreementText
    instructionsText
    questionsPlaceholder
    redirectInstructions
    targetUrlOnRedirect
    waitingSecondsToRedirect
    avatarMedia {
      extensionType
      sourceUuid
      uri
    }
    coverMedia {
      extensionType
      sourceUuid
      uri
    }
  }
`;

export const SegmentationQuestionFields = gql`
  fragment SegmentationQuestionFields on SegmentationQuestion {
    id
    position
    question
  }
`;

export const SmartLinkFields = gql`
  fragment SmartLinkFields on SmartLink {
    id
    url
    title
    subtitle
    btnLabel
    position
    iconMedia {
      extensionType
      sourceUuid
      uri
    }
  }
`;

export const AvailableServiceFields = gql`
  fragment AvailableServiceFields on AvailableService {
    id
    color
    durationMinutes
    name
    priceCents
    pricingType
    btnLabel
    position
    timezone
  }
`;

export const AvailableEventFields = gql`
  fragment AvailableEventFields on AvailableEvent {
    id
    type
    position
    title
    subtitle
    description
    successMessage
  }
`;
